import React from 'react'
import Routes from './routes'
import { connect } from 'react-redux'
import { Switch, Route, withRouter } from 'react-router-dom'
import { Modal, Modals, ModalSwitch } from './components/modals'
import { Event, Events, EventSwitch } from './components/events'
import { AppParallax, AppDrawer } from './components/layout'
import { Views } from './components/views'
import { AppContext } from './helpers'
// import { translate } from './translations'
import { saveEndtest } from '@brainstud/react-tbl/features/account/store'
import { MediaPreloader } from '@brainstud/react-tbl/features/preloader'
import { modalToInstall } from '@brainstud/react-tbl/features/quiz'
import { QuizProvider } from '@brainstud/react-widget-quiz'
// TODO Refactor absolute paths like this
import ContentQuestions from 'content/endtest/Questions'
import ContentModals from 'content/modals'

class App extends React.Component {
  constructor(props) {
    super(props)

    this.toggleModal = (e, name, data) => {
      this.setState(prevState => {
        if (name && prevState.modal !== name)
          return { modal: name, modalData: data }
        else
          return { modal: false, modalData: {} }
      })
    }

    this.toggleNavigation = status => this.setState(prevState => ({ isNavOpen: !prevState.isNavOpen }))
    this.triggerEvent = name => this.setState({ event: name })
    this.triggerTheme = name => this.setState({ theme: name })
    this.setLocation = location => this.setState({ location: location })
    this.setBackground = (image, style) => this.setState({ background: { image, style } })
    this.willProgress = data => this.setState({ checkProgress: data })
    this.didProgress = () => this.setState({ checkProgress: false })

    this.state = {
      modal: false,
      modalData: {},
      toggleModal: this.toggleModal,
      isNavOpen: false,
      toggleNavigation: this.toggleNavigation,
      event: false,
      triggerEvent: this.triggerEvent,
      theme: 'default',
      triggerTheme: this.triggerTheme,
      location: 'home',
      setLocation: this.setLocation,
      background: { image: null, style: {} },
      setBackground: this.setBackground,
      checkProgress: false,
      willProgress: this.willProgress,
      didProgress: this.didProgress,
    }

    this.goToRoute = (location) => {
      const path = {
        home: 'home',
        intro: 'endtest',
        question: 'endtestQuestion',
        summary: 'endtestSummary',
      }

      const data = { [`${location.key}`]: location.value }
      this.toggleModal()
      this.props.history.push(Routes.to(path[location.key], data))
    }

    this.goToModal = (location, data) => {
      const path = {
        'incomplete': 'quiz-incomplete',
        'confirm-submit': 'quiz-confirm-submit',
        'help': 'quiz-help',
      }

      this.toggleModal(null, path[location], data)
    }
  }

  render() {
    return (
      <AppContext.Provider value={this.state}>
        <QuizProvider
          location={this.state.location}
          questionsComponent={ContentQuestions}
          goToRoute={this.goToRoute}
          goToModal={this.goToModal}
          loadedData={this.props.account.endtest}
          saveData={data => this.props.saveEndtest(data)}>
          <AppParallax />
          <AppDrawer />

          <Switch>
            <Route path={Routes.to('home')} exact component={Views.Home} />
            <Route path={Routes.to('chapters')} component={Views.Chapters} />
            <Route path={Routes.to('endtest')} component={Views.Endtest} />
            <Route path={Routes.to('page')} component={Views.Page} />
          </Switch>

          <ModalSwitch>
            <Modal name="logout" noclose component={Modals.Logout} />
            <Modal name="help" component={Modals.Help} />
            <Modal name="summary" component={Modals.Summary} />
            <Modal name="contract-id" component={Modals.ContractId} />
            <Modal name="definition-id" component={Modals.DefinitionId} />
            <Modal name="content-modal" component={Modals.ContentModal} />
            <Modal name="file-modal" component={Modals.FileModal} />

            {modalToInstall.map(modal => (
              <Modal key={modal.path} name={modal.path} component={modal.component} />
            ))}

            {ContentModals.map(modal => (
              <Modal key={modal.path} name={modal.path} component={modal.component} />
            ))}
          </ModalSwitch>

          <EventSwitch>
            <Event name="exit" component={Events.Exit} />
          </EventSwitch>

          <MediaPreloader />
        </QuizProvider>
      </AppContext.Provider>
    )
  }
}

export default withRouter(connect(
  (state) => ({
    account: state.account,
  }),
  (dispatch) => ({
    saveEndtest: data => dispatch(saveEndtest(data))
  })
)(App))
